exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".EmailSent__EmailSentCard___2RxDG {\n  width: 100%;\n  max-width: 500px;\n}\n", "",{"version":3,"sources":["EmailSent.less"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;AAClB","file":"EmailSent.less","sourcesContent":[".EmailSentCard {\n  width: 100%;\n  max-width: 500px;\n}\n"]}]);

// Exports
exports.locals = {
	"EmailSentCard": "EmailSent__EmailSentCard___2RxDG"
};